import { Button, Col, Divider, Row, Space } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ECapReportStepProps } from "../../new-report";
import { AMOUNT_UTIL } from "../../../../../utils/amount.utils";
import "./or-output.scss";

const OROutput = (props: ECapReportStepProps) => {

    const { t } = useTranslation();

    const next = () => {
        if (props.next) {
            props.next();
        }
    }

    useEffect(() => {
    }, [])

    return (
        <div className="step-content-item-wrapper or-output-wrapper">

            <div className="step-content-item-header">
                <h4>
                    {t("EcapModule.ttOROutput")}
                </h4>
            </div>

            <p className="table-des">
                {t("EcapModule.desOROutput")}
            </p>

            <Row gutter={24} className="or-output-table">

                        <Col span={24}>
                            <Row gutter={[24, 24]}>
                                <Col span={6}>
                                </Col>

                                <Col className="text-right" span={9}>
                                    {t("EcapModule.lbNetInterestIncome")}
                                </Col>

                                <Col className="text-right" span={9}>
                                    {t("EcapModule.lbORValue")}
                                </Col>
                            </Row>
                        {
                            props.orOutput?.risk_weighted_equivalents && props.orOutput?.risk_weighted_equivalents.map((item, index) =>

                                <Row className="view-space" gutter={[24, 24]} key={index}>
                                    <Col span={6}>
                                        <b>
                                        {item.year}
                                        </b>
                                    </Col>

                                    <Col className="text-right" span={9}>
                                        <span className="green-text">
                                            {AMOUNT_UTIL.convertNumericToFormattedString(item.net_interest_income)}
                                        </span>
                                        <span className="blue-text">
                                            *
                                        </span>
                                    </Col>

                                    <Col className="red-text text-right" span={9}>
                                        {AMOUNT_UTIL.convertNumericToFormattedString(item.value)}
                                    </Col>
                                </Row>
                            )
                        }
                    </Col>
            </Row>

            <Divider />
            <div className="text-right">

                <div className="title">
                    <Space size="large">
                        <span>
                            {t("EcapModule.lbORCapital")}
                        </span>
                        <span className="red-text">
                            {AMOUNT_UTIL.convertNumericToFormattedString(props.orOutput?.capital_charge)}
                        </span>
                    </Space>
                </div>

                <small className="blue-text">
                    {t("EcapModule.noteNetInterestIncome")}
                </small>

            </div>

            {
                props.next &&
                <div className="action">
                    <Button htmlType="submit" type="primary" shape="round" onClick={next}>
                        {
                            t("RapmReport.btnSubmit")
                        }
                    </Button>
                </div>
            }

        </div>
    )
}

export default OROutput;